module.exports = __webpack_public_path__ + "img/multiple-messages.5e99d934.png";